<div class="container">
    <div class="inner-container">
        <div>
            <h1>Page Unavailable!</h1>
            <lib-action-button
                label="Back to Dashboard"
                fontImage="far fa-long-arrow-left fa-bg"
                [kind]="ActionButtonKind.PRIMARY"
                (click)="onClick()">
            </lib-action-button>
        </div>
    </div>
</div>
